import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ClearQueryParamsService {
  /** The router service injection */
  private readonly _router: Router = inject(Router);

  /**
   * Clears all query parameters from the current URL,
   * except those explicitly listed in the `preserve` array.
   * @param preserve An array of query parameter keys to retain (default is none)
   */
  public clear(preserve: string[] = []): void {
    const currentUrl = this._router.url.split("?")[0];

    const preservedParams: { [key: string]: string } = {};
    const queryParams = new URLSearchParams(window.location.search);

    preserve.forEach((key) => {
      const value = queryParams.get(key);
      if (value !== null) preservedParams[key] = value;
    });

    this._router.navigate([currentUrl], {
      queryParams: preservedParams,
      replaceUrl: true,
    });
  }
}
